import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import Hero from '@/components/Hero';
// import TickerBar from '@/components/TickerBar';
// import CompanyStats from '@/components/home/CompanyStats';
// import HowItWorks from '@/components/home/HowItWorks';
// import Benefits from '@/components/home/Benefits';
// import CustomerCases from '@/components/home/CustomerCases';
// import Industries from '@/components/home/Industries';
import CallToAction from '@/components/home/CallToAction';
// import AIChatPreview from '@/components/home/AIChatPreview';
import SocialProof from '@/components/home/SocialProof';
import ProblemSolution from '@/components/home/ProblemSolution';
import CircularHowItWorks from '@/components/home/CircularHowItWorks';
import KeyMetrics from '@/components/home/KeyMetrics';
import MiniCaseStudies from '@/components/home/MiniCaseStudies';

const Home = () => {
  const location = useLocation();
  const howItWorksRef = useRef<HTMLDivElement>(null);
  const casesRef = useRef<HTMLDivElement>(null);
  const demoRef = useRef<HTMLDivElement>(null);
  const industriesRef = useRef<HTMLDivElement>(null);

  // Handle smooth scrolling to sections when hash changes
  useEffect(() => {
    if (location.hash) {
      let element: HTMLElement | null = null;
      
      switch (location.hash) {
        case '#como-funciona':
          element = howItWorksRef.current;
          break;
        case '#cases':
          element = casesRef.current;
          break;
        case '#demo':
          element = demoRef.current;
          break;
        case '#industries':
          element = industriesRef.current;
          break;
        default:
          break;
      }

      if (element) {
        setTimeout(() => {
          element?.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, [location]);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      {/* <TickerBar /> */}
      <Hero />
      <SocialProof />
      <ProblemSolution />
      <CircularHowItWorks />
      <KeyMetrics />
      <MiniCaseStudies />
      {/* <CompanyStats /> */}
      {/* <div ref={howItWorksRef}>
        <HowItWorks />
      </div> */}
      {/* <Benefits /> */}
      {/* <div ref={industriesRef}>
        <Industries />
      </div> */}
      {/* <div ref={casesRef}>
        <CustomerCases />
      </div> */}
      <div ref={demoRef}>
        <CallToAction />
      </div>
      <Footer />
    </div>
  );
};

export default Home;
